import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
import {useMutation} from 'react-query';

import PutStoreRedesignView from '.';

interface IPostStoreRedesignViewProps {
  onSuccess?: () => void;
}
interface AxError {
  message: string;
}
const usePutStoreRedesignView = ({onSuccess}: IPostStoreRedesignViewProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IStoreLabRedesignView) => {
      return PutStoreRedesignView(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess();
    },
    onError: (data: AxiosError<AxError>) => {
      toast.error(data?.response?.data?.message || 'مشکلی پیش آمده است');
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePutStoreRedesignView};
